module.exports = __webpack_public_path__ + "static/img/jibing2.a207c01.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home/jibing2.jpeg
// module id = FRne
// module chunks = 1